import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
	selector: 'app-sidebar-header',
	templateUrl: './app-sidebar-header.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./app-sidebar-header.component.scss'],
})
export class AppSidebarHeaderComponent {}
